import { apiFetch } from "../client"

export interface PortalAuthClient {
  clientId: string
  fullName: string
  phoneNumber: string
  altPhone?: string | null
  physicalAddress?: string | null
  preferredLanguage?: string
  kycStatus?: string
}

export type ClientOtpFlow = "LOGIN" | "REGISTER"

export interface RegistrationPayload {
  registrationToken: string
  fullName: string
  dateOfBirth: string
  gender: "MALE" | "FEMALE" | "OTHER"
  altPhone?: string | null
  physicalAddress: string
  nationalId: string
  preferredLanguage: "en" | "sn"
  nextOfKin: {
    fullName: string
    relationship: string
    phoneNumber: string
  }
}

export async function requestOtp(phoneNumber: string) {
  return apiFetch<{
    status: string
    data: { message: string; expiresIn: number; flow?: ClientOtpFlow }
  }>(
    "/auth/otp/request",
    {
      method: "POST",
      rawBody: { phoneNumber, loginScope: "CLIENT" },
    },
  )
}

export async function verifyOtp(phoneNumber: string, otp: string) {
  return apiFetch<{
    status: string
    data: {
      expiresAt: string
      client: PortalAuthClient
    }
  }>("/auth/otp/verify", {
    method: "POST",
    rawBody: { phoneNumber, otp, loginScope: "CLIENT" },
  })
}

export async function requestRegistrationOtp(phoneNumber: string) {
  return apiFetch<{ status: string; data: { message: string; expiresIn: number } }>(
    "/auth/client-registration/otp/request",
    {
      method: "POST",
      rawBody: { phoneNumber },
    },
  )
}

export async function verifyRegistrationOtp(phoneNumber: string, otp: string) {
  return apiFetch<{
    status: string
    data: {
      registrationToken: string
    }
  }>("/auth/client-registration/otp/verify", {
    method: "POST",
    rawBody: { phoneNumber, otp },
  })
}

export async function completeRegistration(payload: RegistrationPayload) {
  return apiFetch<{
    status: string
    data: {
      expiresAt: string
      client: PortalAuthClient
    }
  }>("/auth/client-registration/complete", {
    method: "POST",
    rawBody: payload,
  })
}

export async function logout() {
  return apiFetch<{ status: string; data: { message: string } }>("/auth/logout", {
    method: "POST",
  })
}
